import reportsMapper from '../mappers/reportsMapper';
import { RETRIEVE_OUTBOUND_REPORTS_SUCCESS } from '../actions/types/ReportsActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = [];

export const outboundReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_OUTBOUND_REPORTS_SUCCESS:
      return reportsMapper(action.payload);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

